import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ButtonFactoryService } from '../button-factory.service';
import { ButtonItem } from '../button.model';
import { DqcsEventsService } from 'sce-core';

@Component({
  selector: 'lfwms-button-panel-header',
  templateUrl: './button-panel-header.component.html',
  styleUrls: ['./button-panel-header.component.css']
})
export class ButtonPanelHeaderComponent {

  @Input()
  buttonArray: Array<ButtonItem>;

  @Input()
  tableId = '';

  @Output()
  buttonClickHandler: EventEmitter<string> = new EventEmitter();

  constructor(
    private readonly factoryService: ButtonFactoryService,
    private readonly dqcsEventService: DqcsEventsService
  ) {}

  public handleButtonClick(button: ButtonItem) {
    if (button.subItems && button.subItems.length === 0) {
      this.dqcsEventService.publishButtonClickEvent({
        action: button.elementId,
        accessPrivilege: button.accessPrivilege,
        table: this.tableId
      })
    }

    this.buttonClickHandler.emit(button.action);
  }
  // Method is used to check whether the user having corresponding privilege code to enable the button
  public checkButtonPrivilege(privilege: String) {
    return this.factoryService.checkButtonPrivilege(privilege);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/button/button-panel-header/button-panel-header.component.ts